import { Boundaries } from "@planzone/core";
import { account, id, role } from "@planzone/dto";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  role: { uuid: id, ...role },
  account,
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
};

function handleRequest(state: State): State {
  return {
    ...initialState,
    request: setRequestStateToPending(),
  };
}

function handleSuccess(
  state: State,
  { role, account }: Boundaries["retrievePlanzoneRole"]["success"],
): State {
  return { role, request: setRequestStateToSuccess(), account };
}

function handleFailure(state: State): State {
  return {
    ...state,
    request: setRequestStateToFailure(),
  };
}

function handleResourceEdition(
  state: State,
  resource: Boundaries["editResource"]["success"],
): State {
  return resource.uuid === state.account.resource.uuid
    ? { ...state, role: resource.role || state.role }
    : state;
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrievePlanzoneRoleRequested]: handleRequest,
    [events.retrievePlanzoneRoleSucceeded]: handleSuccess,
    [events.retrievePlanzoneRoleFailed]: handleFailure,
    [events.editResourceSucceeded]: handleResourceEdition,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
